module.exports = __webpack_public_path__ + "img/qywh-bg.8bedcb18.png";